import Timesheets from './pages/Timesheets/TimesheetsComponent';
import Dashboard from './pages/Dashboard/DashboardComponent';
import Leaves from './pages/Leaves/LeavesComponent';
import People from './pages/People/PeopleComponent';
import Manage from './pages/Manage/ManageComponent';
import UserProfile from './pages/Profile/ProfileComponent';
import WorkReports from './pages/WorkReports/ViewWorkReport';
import UserWorkReportsComponent from './pages/WorkReports/UserWorkReportsComponent';
import LeavesReport from './pages/Reports/LeavesReport';
import PayrollReport from './pages/Reports/PayrollReport';
import MasterData from './admin/pages/MasterData/MasterData';
import EmployeePrivilegesTabComponent from './admin/pages/EmployeePrivileges/EmployeePrivilegesTabComponent';
import QuarterlyCasualLeaveAllocationComponent from './admin/pages/QuarterlyCasualLeave/QuarterlyCasualLeaveAllocationComponent';
import ReportComponent from './admin/pages/Reports/ReportComponent';
import WorkFromHome from './pages/WFH/WorkFromHome';
import RandomRouteComponent from './pages/ExceptionPages/RandomRouteComponent';
import EmptyComponent from './pages/ExceptionPages/EmptyComponent';
import NoRoleComponent from './pages/ExceptionPages/NoRoleComponent';
import ManageAllLeavesRequests from './hr/pages/Leaves/ManageAllLeaveRequests';
import Normalization from './pages/Normalization/Normalization';
import BulkUploadComponent from './hr/pages/BulkUpload/BulkUploadComponent';
import EmployeeMasterCsvComponent from './hr/pages/EmployeeMasterCsv/EmployeeMasterCsvComponent';
import ManageHrWfhRequests from './hr/pages/Leaves/ManageHrWfhRequests';
import EmployeeOnboardingComponent from './pages/EmployeeOnboarding/EmployeeOnboardingComponent';
import ApproveSkill from './tech-council/Pages/ApproveSkill';
import EmployeeSummaryTabComponent from './pages/EmployeeSummary/EmployeeSummaryTabComponent';
import EmployeeOffboardingComponent from './pages/EmployeeOffboarding/EmployeeOffboardingComponent';
import TeamComponent from './pages/Team/TeamComponent';
import ManageProjectAdmin from './admin/pages/Manage/ManageAdminComponent';
import ExternalHours from './components/ExternalHOurs/ExternalHours';
import TasksDynamicTabs from './pages/Tasks/TasksDynamicTabs';
import ProjectReportComponent from './admin/pages/Reports/ProjectReportComponent';
import SeniorManagerWfhQuotaComponent from './pages/SeniorManager/SeniorManagerWfhQuotaComponent';
import SeniorManagerWfhRequestsComponent from './pages/SeniorManager/SeniorManagerWfhRequestsComponent';
import SeniorManagerLeaveRequestsComponent from './pages/SeniorManager/SeniorManagerLeaveRequestsComponent';
import SeniorManagerRemoteOfficeHoursComponent from './pages/SeniorManager/SeniorManagerRemoteOfficeHoursComponent';

export const flattenRoutes = (routes = []) =>
  routes.flatMap((route) =>
    route.children?.length ? flattenRoutes(route.children) : [route],
  );

export const EmployeeRoutes = [
  {
    key: 'dashboard',
    title: 'Dashboard',
    path: '/user-dashboard',
    enabled: true,
    component: Dashboard,
  },
  {
    key: 'timings',
    title: 'Timings',
    path: '/user-timings',
    enabled: true,
    component: Timesheets,
  },
  {
    key: 'leaves',
    title: 'Leaves',
    path: '/user-leaves',
    enabled: true,
    component: Leaves,
  },
  {
    key: 'WFH',
    title: 'WFH',
    path: '/WFH',
    enabled: true,
    component: WorkFromHome,
  },
  {
    key: 'tasks',
    title: 'Tasks',
    path: '/user-tasks',
    enabled: true,
    component: TasksDynamicTabs,
  },
  {
    key: 'work-reports',
    title: 'Reports',
    path: '/user-work-reports',
    enabled: true,
    component: UserWorkReportsComponent,
  },
  {
    key: 'teams',
    title: 'Teams',
    path: '/user-teams',
    enabled: true,
    component: TeamComponent,
  },
  {
    key: 'People',
    title: 'People',
    path: '/user-people',
    enabled: true,
    component: People,
  },
  {
    key: 'manage',
    title: 'Manage',
    path: '/user-manage',
    enabled: true,
    component: Manage,
  },
  {
    key: 'Profile',
    title: 'Profile',
    path: '/user-profile',
    enabled: true,
    component: UserProfile,
  },
];

export const ReportRoutes = [
  {
    key: 'payrollReport',
    title: 'Payroll',
    path: '/report-payroll-report',
    enabled: true,
    component: PayrollReport,
  },
  {
    key: 'leavesReport',
    title: 'Leaves',
    path: '/report-leaves-report',
    enabled: true,
    component: LeavesReport,
  },
];

export const HRRoutes = [
  {
    key: 'masterData',
    title: 'Master Data',
    path: '/hr-master-data',
    enabled: true,
    component: MasterData,
  },
  {
    key: 'bulkUpload',
    title: 'Bulk Upload',
    path: '/hr-bulk-upload',
    enabled: true,
    component: BulkUploadComponent,
  },
  {
    key: 'employeeMasterCsv',
    title: 'Employee CSV',
    path: '/hr-employee-csv',
    enabled: true,
    component: EmployeeMasterCsvComponent,
  },
  {
    key: 'leaves',
    title: 'Leaves',
    path: '/hr-leaves',
    enabled: true,
    component: ManageAllLeavesRequests,
  },
  {
    key: 'WFH',
    title: 'WFH',
    path: '/hr-WFH',
    enabled: true,
    component: ManageHrWfhRequests,
  },
  {
    key: 'normalization',
    title: 'Normalization',
    path: '/hr-normalization',
    enabled: true,
    component: Normalization,
  },
  {
    key: 'reports',
    title: 'Reports',
    path: '/hr-reports',
    enabled: true,
    component: ReportComponent,
  },
  {
    key: 'project-report',
    title: 'Project Reports',
    path: '/hr-project-report',
    enabled: true,
    component: ProjectReportComponent,
  },
  {
    key: 'work-reports',
    title: 'Reports',
    path: '/hr-work-reports',
    enabled: true,
    component: WorkReports,
  },
  {
    key: 'employeeOnboarding',
    title: 'Employee Onboarding',
    path: '/hr-employee-onboarding',
    enabled: true,
    component: EmployeeOnboardingComponent,
  },
  {
    key: 'employeeOffboarding',
    title: 'Employee Offboarding',
    path: '/hr-employee-offboarding',
    enabled: true,
    component: EmployeeOffboardingComponent,
  },
  {
    key: 'employeeSummary',
    title: 'Employee Summary',
    path: '/hr-employee-summary',
    enabled: true,
    component: EmployeeSummaryTabComponent,
  },
  {
    key: 'Employee Privileges',
    title: 'Employee Privileges',
    path: '/hr-employee-privileges',
    enabled: true,
    component: EmployeePrivilegesTabComponent,
  },
  {
    key: 'Quarterly Casual Leave',
    title: 'Quarterly Casual Leave',
    path: '/hr-quarterly-casual-leave',
    enabled: true,
    component: QuarterlyCasualLeaveAllocationComponent,
  },
];

export const FinanceRoutes = [
  {
    key: 'externalHours',
    title: 'External Hours',
    path: '/finance-external',
    enabled: true,
    component: ExternalHours,
  },
  {
    key: 'clientOfficeHours',
    title: 'Client Office Hours',
    path: '/finance-client-office',
    enabled: true,
    component: ExternalHours,
  },
  {
    key: 'workTravelHours',
    title: 'Work Travel Hours',
    path: '/finance-work-travel',
    enabled: true,
    component: ExternalHours,
  },
  {
    key: 'reports',
    title: 'Reports',
    path: '/finance-reports',
    enabled: true,
    component: ReportComponent,
  },
  {
    key: 'project-report',
    title: 'Project Reports',
    path: '/finance-project-report',
    enabled: true,
    component: ProjectReportComponent,
  },
  {
    key: 'work-reports',
    title: 'Reports',
    path: '/finance-work-reports',
    enabled: true,
    component: WorkReports,
  },
];

export const SeniorManagerRoutes = [
  {
    key: 'leaveRequests',
    title: 'Leave Requests',
    path: '/senior-manager-leave',
    enabled: true,
    component: SeniorManagerLeaveRequestsComponent,
  },
  {
    key: 'wfhQuotaRequests',
    title: 'WFH Quota Requests',
    path: '/senior-manager-wfh-quota',
    enabled: true,
    component: SeniorManagerWfhQuotaComponent,
  },
  {
    key: 'wfhRequests',
    title: 'WFH Requests',
    path: '/senior-manager-wfh',
    enabled: true,
    component: SeniorManagerWfhRequestsComponent,
  },
  {
    key: 'clientOfficeHours',
    title: 'Client Office Hours',
    path: '/senior-manager-client-office',
    enabled: true,
    component: ExternalHours,
  },
  {
    key: 'remoteOfficeHours',
    title: 'Remote Office Hours',
    path: '/senior-manager-remote-office-hours',
    enabled: true,
    component: SeniorManagerRemoteOfficeHoursComponent,
  },
  {
    key: 'reports',
    title: 'Reports',
    path: '/senior-manager-reports',
    enabled: true,
    component: ReportComponent,
  },
];

export const TechCouncilRoutes = [
  {
    key: 'approveSkill',
    title: 'Approve Skill',
    path: '/tech-council',
    enabled: true,
    component: ApproveSkill,
  },
];

export const ProjectAdminRoutes = [
  {
    key: 'projects',
    title: 'Projects',
    path: '/project-admin',
    enabled: true,
    component: ManageProjectAdmin,
  },
  {
    key: 'work-reports',
    title: 'Reports',
    path: '/project-work-reports',
    enabled: true,
    component: WorkReports,
  },
];

export const DefaultRoutes = [
  {
    key: 'defaulterDashboard',
    title: 'NoRole',
    path: '/no-role',
    enabled: true,
    component: NoRoleComponent,
  },
  {
    key: 'home',
    title: 'Home',
    path: '/',
    enabled: true,
    component: EmptyComponent,
  },
  {
    key: 'noSuchRoute',
    title: 'NoSuchRoute',
    path: '',
    enabled: true,
    component: RandomRouteComponent,
  },
];
